import { render, staticRenderFns } from "./TheBody.vue?vue&type=template&id=da5d1c10&"
import script from "./TheBody.vue?vue&type=script&lang=js&"
export * from "./TheBody.vue?vue&type=script&lang=js&"
import style0 from "./TheBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports